module.exports = __webpack_public_path__ + "static/media/season-end-header-icon.c9b82d7d.svg";